import * as React from "react";
import { Radio, Clock, CalendarDays } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const stages = [{
  id: 1,
  slot: "Morning",
  time: "12:00 PM",
  endTime: "4:00 PM",
  artist: "The Sunsets",
  bio: "Kicking off the day with acoustic beach vibes, classic rock covers, and laid-back energy to start your Fort Lauderdale experience right.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/morning_acoustic_band.png"
}, {
  id: 2,
  slot: "Afternoon",
  time: "4:30 PM",
  endTime: "8:30 PM",
  artist: "Tide Riders",
  bio: "High-energy reggae, ska, and upbeat anthems to keep the afternoon party going strong as the sun begins to set over the strip.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/afternoon_reggae_band.png"
}, {
  id: 3,
  slot: "Night",
  time: "9:00 PM",
  endTime: "2:00 AM",
  artist: "Neon Nights",
  bio: "Closing out the night with electrifying synth-pop, modern hits, and a high-octane performance that defines the Elbo Room after dark.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/night_synth_band.png"
}];
export default function TodaysStageRotation() {
  return <section id="todays-stage-rotation" className="dark bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div>
            <div className="flex items-center gap-2 text-primary mb-3">
              <CalendarDays className="w-5 h-5" />
              <span className="font-mono text-sm tracking-wider uppercase">
                Live Daily Shows
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl font-serif uppercase tracking-tight">
              Today's Stage <span className="text-primary">Rotation</span>
            </h2>
            <p className="text-muted-foreground mt-4 max-w-xl text-lg">
              Three bands daily. Non-stop energy. Experience the definitive sound of Fort Lauderdale beach from noon till late.
            </p>
          </div>
          <div className="flex items-center gap-4 bg-card/50 backdrop-blur-sm border border-border/50 px-6 py-3 rounded-full">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-destructive opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-destructive"></span>
            </span>
            <span className="font-mono text-sm tracking-widest uppercase">
              Beach Radio Live
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {stages.map((stage, i) => <Card key={stage.id} data-index={i} className="group relative h-[500px] lg:h-[600px] overflow-hidden border-0 rounded-2xl bg-card shadow-2xl">
              {}
              <img src={stage.image} alt={stage.artist} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" />

              {}
              <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-transparent to-transparent" />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/90 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-100" />

              {}
              <div className="absolute inset-0 p-6 lg:p-8 flex flex-col justify-end z-10">
                <div className="transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
                  {}
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background/50 backdrop-blur-md border border-white/10 mb-6">
                    <Clock className="w-3.5 h-3.5 text-primary" />
                    <span className="text-xs font-bold tracking-widest uppercase text-foreground">
                      {stage.slot}
                    </span>
                  </div>

                  {}
                  <div className="mb-2">
                    <h3 className="text-6xl lg:text-7xl font-serif text-primary leading-none tracking-tight drop-shadow-[0_0_15px_rgba(245,158,11,0.3)]">
                      {stage.time}
                    </h3>
                    <p className="text-muted-foreground font-mono text-sm mt-2 mb-4">
                      UNTIL {stage.endTime}
                    </p>
                    <h4 className="text-3xl font-bold text-foreground tracking-tight">
                      {stage.artist}
                    </h4>
                  </div>

                  {}
                  <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
                    <div className="overflow-hidden">
                      <p className="text-muted-foreground text-sm leading-relaxed pt-2 pb-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                        {stage.bio}
                      </p>
                    </div>
                  </div>

                  {}
                  <Button variant="default" size="lg" className="w-full group/btn relative overflow-hidden bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300">
                    <span className="absolute inset-0 bg-white/20 translate-y-full group-hover/btn:translate-y-0 transition-transform duration-300 ease-out" />
                    <Radio className="mr-2 h-5 w-5 relative z-10 group-hover/btn:animate-pulse" />
                    <span className="relative z-10 font-bold tracking-wide uppercase">
                      Listen Live
                    </span>
                  </Button>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}